<template>
    <div class="preview-message">
        <preview-icon />

        <em>
            {{ t('previewMessage') }}
        </em>
    </div>
</template>

<script setup lang="ts">
    import PreviewIcon from '@/assets/preview.svg?component';
    import { useI18n } from 'vue-i18n';
    import messages from './PreviewMessage.messages.json';

    const { t } = useI18n({ messages });
</script>

<style scoped lang="scss">
    .preview-message {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 2rem;
        gap: 1rem;
        text-align: center;
    }
</style>
